<script>
  import { 
    Block, Row, Column, FileInput, Image, TextInput, Text, CheckBox
  } from 'bastone'
  import Header from '../components/header.svelte'
  import Page from '../components/page.svelte'
  import MyButton from '../components/button.svelte'
  import { currentUser, Context } from '../context'
  import { colors, fileBaseUrl } from '../consts'
  import { ApiClient } from '../models'
  import { upload, getByteLength } from '../utils'
  import { onMount } from 'svelte'

  let avatarInput = null
  let uploadToken = null
  let resetPass = false
  let errorMessage = ''
  $: user = $currentUser || {}


  function uploadAvatar() {
    if (avatarInput.files.length < 1) {
      return
    }
    
    if (uploadToken === null) {
      notify('获取上传token失败')
      return
    }

    let file = avatarInput.files[0]
    if (file.size > 5 * 1024 * 1024) {
      errorMessage = '文件大小不能超过5MB'
      return
    }

    let key = `images/${user.id}_avatar_${Date.now()}`
    upload(file, key, uploadToken, ()=>{
      user.avatar = fileBaseUrl + key + '-avatar'
    })
  }

  async function save() {
    if (!user.name || getByteLength(user.name) > 12) {
      errorMessage = '用户名长度错误'
      return
    }

    if (resetPass) {
      let len = user.password ? user.password.length : 0
      if (len < 6 || len > 18) {
        errorMessage = '密码长度必须为6~18位'
        return
      }
      user.setValue('password', user.password)
    }
    
    let res = await user.update()
    if (res) {
      Context.setUser(user)
      history.length > 1 ? history.back() : location.href='/chat'
    } else {
      errorMessage = '保存失败,请联系客服'
    }
  }

  onMount(()=>{
    ApiClient.getUploadToken().then((token) => {
      uploadToken = token
    })
  })

</script>


<Page title=用户信息>
  <Header buttonType='back'/>
  <Block minHeight=3rem/>
  <Row align=center>
    <Column>
      <Row align=center>
        <FileInput bind:input={avatarInput} accept=".jpg,.jpeg,.png" on:change={uploadAvatar}>
          <Column xAlign=center>
            <Image bind:url={user.avatar} height=3.5rem radius=50%></Image>
            <Block height=0.4rem/>
            <Text>点击上传</Text>
          </Column>
        </FileInput>
      </Row>
      <Block height=2.5rem/>

      <Row>
        <Row height=2rem width=5.5rem>
          <Text size=1.1rem>用户名</Text>
        </Row>
        <TextInput 
          width=16rem height=2rem bind:value={user.name}
        ></TextInput>
      </Row>
      <Block height=1rem/>

      <Row>
        <Row height=2rem width=5.5rem>
          <Text size=1.1rem>手机号</Text>
        </Row>
        <TextInput 
          width=16rem height=2rem value={user.mobile} readonly=1 backgroundColor={colors.snow}
        ></TextInput>
      </Row>
      <Block height=1rem/>

      <Row>
        <Row height=2rem width=5.5rem>
          <Text size=1.1rem>个性签名</Text>
        </Row>
        <TextInput placeholder=一句话介绍自己
          width=16rem height=2rem bind:value={user.desc}
        ></TextInput>
      </Row>
      <Block height=1rem/>

      {#if resetPass}
      <Row>
        <Row height=2rem width=5.5rem>
          <Text size=1.1rem>新密码</Text>
        </Row>
        <TextInput isPassword=1 width=16rem height=2rem
          bind:value={user.password}
        ></TextInput>
      </Row>
      <Block height=1rem/>
      {/if}

      <Row>
        <Block width=5.5rem/>
        <CheckBox 
          iconColor={colors.black} size=1rem border=2 borderColor={colors.lightGray} space=0.4rem
          bind:checked={resetPass}
        ><Text size=1rem lineHeight=1.4rem>重置密码</Text>
        </CheckBox>
      </Row>
      <Block height=1rem/>

      {#if errorMessage}
      <Row>
        <Block width=5.5rem/>
        <Text color={colors.red} width=16rem wrap=1>{errorMessage}</Text>
      </Row>
      <Block height=1rem/>
      {/if}

      <Block height=0.5rem/>
      <Row>
        <Block width=5.5rem/>
        <MyButton
          fill=1 width=6rem height=2rem fontSize=1rem
          on:click={save}
        >保存</MyButton>
        <Block width=1rem/>
        <MyButton 
          on:click={()=>(history.length>1?history.back():location.href='/chat')} 
          width=6rem height=2rem fontSize=1rem
        >取消</MyButton>
      </Row>

    </Column>
  </Row>

</Page>
